'use client'

import CardPlacingOrder from '@/entities/cart-page/CardPlacingOrder'
import { useGetCartInfoQuery } from '@/shared/api-rtk/api-list/cartApi'
import {
    changeCurrentStep,
    changePaymentMethodValue,
    changeShippingMethodValue,
    updateShippingMethod,
} from '@/shared/store/slice/cartSlice'
import { useEffect } from 'react'
import { Form, InputGroup } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import './ShippingMethods.css'

export const ShippingMethods = ({ userInfo }) => {
    const {
        areaType,
        currentStep: step,
        shippingMethodValue: value,
    } = useSelector((state) => state.cartActions)

    const dispatch = useDispatch()
    const { refetch } = useGetCartInfoQuery()

    const handleChange = (e) => {
        const selected = e.target.value
        dispatch(changeShippingMethodValue(selected))
        dispatch(changePaymentMethodValue(null))
    }

    const handleChangeStep = async () => {
        if (!value) return
        let body = { shipping_method: value, userInfo }
        await dispatch(updateShippingMethod(body))
        await refetch()
        dispatch(changeCurrentStep(3))
    }

    return (
        <CardPlacingOrder
            stepTitle={'Шаг 2: Способ доставки'}
            changeStep={handleChangeStep}
            className={step < 2 ? 'disabled-step' : ''}
            currentStep={step === 2}
            textButton={'Следующий шаг'}
            isValid={!!value} // <-- можно перейти дальше, только если выбрана доставка
        >
            <h3>Выберите подходящий способ доставки:</h3>

            {/* Для "Другого города" */}
            {areaType === 'another' && (
                <InputGroup>
                    <Form.Check
                        id="flat"
                        value={'flat.flat'}
                        type={'radio'}
                        name="shipping_method"
                        onChange={handleChange}
                        checked={value === 'flat.flat'}
                    />
                    <label htmlFor="flat">
                        <span>Доставка</span>
                    </label>
                </InputGroup>
            )}

            {/* Для всех остальных */}
            {areaType !== 'another' && (
                <>
                    <InputGroup>
                        <Form.Check
                            id="flat"
                            value={'flat.flat'}
                            type={'radio'}
                            name="shipping_method"
                            onChange={handleChange}
                            checked={value === 'flat.flat'}
                        />
                        <label htmlFor="flat">
                            <span>Доставка курьерской службой до двери</span>
                        </label>
                    </InputGroup>

                    {areaType === 'msk.inside-mkad' && (
                        <InputGroup>
                            <Form.Check
                                id="pickup"
                                value={'pickup.pickup'}
                                type={'radio'}
                                name="shipping_method"
                                onChange={handleChange}
                                checked={value === 'pickup.pickup'}
                            />
                            <label htmlFor="pickup">
                                <span>Самовывоз</span>
                            </label>
                        </InputGroup>
                    )}
                </>
            )}
        </CardPlacingOrder>
    )
}
